import { Injectable } from '@angular/core';
import {Patient} from "./patient/patient";

@Injectable()
export class PatientsManagerService {
  patients: Patient[];
  static transportType: string;
  
  constructor() {
    this.clear();
    this.add();
  }

  add(){
    this.patients.push(new Patient());
  }

  clear(){
    this.patients = [];
  }

  private static normalizeDate(date: string){
    return date.substr(4, 4) + "-" + date.substr(2, 2) + "-" + date.substr(0, 2)
  }

  public static getPatientDemo(){
    return Patient.create({
      "prescription": {
        "date": "01032016",
        "transport": {
          "custom": {
            "date": "01032016",
            "mode": "TXI",
            "dateATMP": "12051989",
            "motifs": ["ALD"]
          }
        }
      },
      "nir": {
        "num": "1650163220102",
        "key": "18"
      },
      "birthday": "01011965",
      "row": "1",
      "type": "assure",
      "social": {
        "grandRegime": "01"
      }
    })
  }

  public static makeJSON(patient: Patient){

    let custom = {
      "date": this.normalizeDate(patient.realisationDate),
        "mode": this.transportType.toUpperCase(),
        "motifs": []
    };

    if (patient.isALD && !patient.isL115){
      custom.motifs.push("ALD");
    }

    if (patient.pec100 && !patient.isL115){
      custom.motifs.push("CDP100");
    }

    if (patient.isATMP && !patient.isL115){
      custom.motifs.push("AT");
      if (patient.atID != ""){
        custom["identifiant_at"] = patient.atID;
      } else if (patient.atDate != "") {
        custom["dateATMP"] = this.normalizeDate(patient.atDate);
      }
    }
    
    if (patient.isL115){
      custom.motifs.push("L115");
    }

    return {
      "prescription": {
        "date": this.normalizeDate(patient.prescriptionDate),
          "transport": {
          "custom": custom
        }
      },
      "nir": {
        "num": patient.nir.num,
        "key": patient.nir.key
      },
        "birthday": this.normalizeDate(patient.birthday),
        "row": patient.rang,
        "type": "assure",
        "social": {
          "grandRegime": patient.regime
        }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/patients-manager.service.ts